import { ValidationError } from "@common/types";

export class ProjectEditorViewModel
{
    opened: boolean = false;

    projectId: number | null = null;
    name: string | null = null;
    description: string | null = null;

    updating: boolean = false;
    deleting: boolean = false;

    nameError: string | null = null;
    descriptionError: string | null = null;

    show(projectId: number, name: string, description: string | null)
    {
        this.projectId = projectId;
        this.name = name;
        this.description = description;

        this.updating = false;
        this.deleting = false;

        this.clearValidationErrors();

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.projectId = null;
        this.name = null;
        this.description = null;

        this.updating = false;
        this.deleting = false;

        this.clearValidationErrors();
    }


    displayValidationErrors(errors: ValidationError[])
    {
        this.updating = false;
        this.deleting = false;

        for (const error of errors)
        {
            if (error.Context === "Name")
            {
                this.nameError = error.Error;
            }
            else if (error.Context === "Description")
            {
                this.descriptionError = error.Error;
            }
        }
    }

    clearValidationErrors()
    {
        this.nameError = null;
        this.descriptionError = null;
    }

}

